import { useParams } from 'react-router';

import {
  useGetAdmissionApplicationQuery,
  useGetAdmissionSurveyQuery,
} from '@/api/endpoints/schools/schoolSelectionPanel';
import { FetchDataWrapper } from '@/shared/components';

import { CurrentApplicationPage } from './CurrentApplicationPage';

export const CurrentApplicationPageWrapper = () => {
  const { id: schoolId, applicationId } = useParams();

  const {
    data: applicationData,
    isLoading: isApplicationLoading,
    isError: isApplicationFetchError,
  } = useGetAdmissionApplicationQuery({
    schoolId: Number(schoolId),
    applicationId: Number(applicationId),
  });
  const {
    data: surveyData,
    isLoading: isSurveyLoading,
    isFetching: isSurveyFetching,
    isError: isSurveyFetchError,
  } = useGetAdmissionSurveyQuery({
    schoolId: Number(schoolId),
  });

  return (
    <FetchDataWrapper
      isLoading={isApplicationLoading || isSurveyLoading}
      isError={isApplicationFetchError || isSurveyFetchError}
    >
      {applicationData && surveyData && (
        <CurrentApplicationPage
          applicationData={applicationData}
          schoolId={Number(schoolId)}
          surveyStatus={surveyData.status}
          isSurveyFetching={isSurveyFetching}
        />
      )}
    </FetchDataWrapper>
  );
};
